// src/routes/AppRoutes.js
// Configuration du routage Fynho - Voyages remplacé par Récemment consultées - NE PAS MODIFIER

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ROUTES from '../constants/routes';
import { useAuth } from '../hooks/useAuth';

import Home from '../pages/Home';
import Search from '../pages/Search';
import MapSearch from '../pages/MapSearch';
import ListingDetail from '../pages/ListingDetail';
import Sejours from '../pages/Sejours';
import Locations from '../pages/Locations';
import Immobilier from '../pages/Immobilier';
import Services from '../pages/Services';
import Favorites from '../pages/Favorites';
import RecentlyViewed from '../pages/RecentlyViewed';

import Login from '../pages/auth/Login';
import Register from '../pages/auth/Register';
import ForgotPassword from '../pages/auth/ForgotPassword';
import ResetPassword from '../pages/auth/ResetPassword';

import Profile from '../pages/Profile';
import Notifications from '../pages/user/Notifications';
import Messages from '../pages/user/Messages';
import Settings from '../pages/user/Settings';
import Support from '../pages/user/Support';

import AdminLogin from '../pages/admin/AdminLogin';
import AdminDashboard from '../pages/admin/AdminDashboard';
import AdminReservations from '../pages/admin/AdminReservations';
import AdminListings from '../pages/admin/AdminListings';
import AdminAddListing from '../pages/admin/AdminAddListing';
import AdminEditListing from '../pages/admin/AdminEditListing';
import AdminOwners from '../pages/admin/AdminOwners';
import AdminQuartiers from '../pages/admin/AdminQuartiers';
import AdminTypes from '../pages/admin/AdminTypes';
import AdminUsers from '../pages/admin/AdminUsers';
import AdminAdmins from '../pages/admin/AdminAdmins';
import AdminStats from '../pages/admin/AdminStats';
import AdminAuditLogs from '../pages/admin/AdminAuditLogs';

import MainLayout from '../layouts/MainLayout';

const ProtectedRoute = ({ children, isAuthenticated }) => {
  if (!isAuthenticated) return <Navigate to={ROUTES.LOGIN} replace />;
  return children;
};

const AdminProtectedRoute = ({ children, isAuthenticated }) => {
  if (!isAuthenticated) return <Navigate to={ROUTES.ADMIN_LOGIN} replace />;
  return children;
};

const AppRoutes = () => {
  const { isAuthenticated, isAdminAuthenticated, loading } = useAuth();

  if (loading) return null;

  return (
    <Router>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path={ROUTES.HOME} element={<Home />} />

          <Route path={ROUTES.SEJOURS} element={<Sejours />} />
          <Route path={ROUTES.LOCATIONS} element={<Locations />} />
          <Route path={ROUTES.IMMOBILIER} element={<Immobilier />} />
          <Route path={ROUTES.SERVICES} element={<Services />} />

          <Route path={ROUTES.LISTING_DETAIL} element={<ListingDetail />} />
          <Route path={ROUTES.SEARCH} element={<Search />} />
          <Route path={ROUTES.MAP_SEARCH} element={<MapSearch />} />

          <Route path={ROUTES.FAVORITES} element={<Favorites />} />
          {/* Cette route servait à "Voyages" - elle affiche désormais l'historique de consultation */}
          <Route path={ROUTES.RESERVATIONS} element={<RecentlyViewed />} />

          <Route path={ROUTES.LOGIN} element={<Login />} />
          <Route path={ROUTES.REGISTER} element={<Register />} />
          <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />
          <Route path={ROUTES.RESET_PASSWORD} element={<ResetPassword />} />

          <Route path={ROUTES.PROFILE} element={<Profile />} />
          <Route
            path={ROUTES.NOTIFICATIONS}
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Notifications />
              </ProtectedRoute>
            }
          />
          <Route path={ROUTES.MESSAGES} element={<Messages />} />
          <Route
            path={ROUTES.SETTINGS}
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route path={ROUTES.SUPPORT} element={<Support />} />
        </Route>

        <Route path={ROUTES.ADMIN_LOGIN} element={<AdminLogin />} />

        <Route
          path={ROUTES.ADMIN_DASHBOARD}
          element={<AdminProtectedRoute isAuthenticated={isAdminAuthenticated}><AdminDashboard /></AdminProtectedRoute>}
        />
        <Route
          path={ROUTES.ADMIN_LISTINGS}
          element={<AdminProtectedRoute isAuthenticated={isAdminAuthenticated}><AdminListings /></AdminProtectedRoute>}
        />
        <Route
          path={ROUTES.ADMIN_ADD_LISTING}
          element={<AdminProtectedRoute isAuthenticated={isAdminAuthenticated}><AdminAddListing /></AdminProtectedRoute>}
        />
        <Route
          path={ROUTES.ADMIN_EDIT_LISTING}
          element={<AdminProtectedRoute isAuthenticated={isAdminAuthenticated}><AdminEditListing /></AdminProtectedRoute>}
        />
        <Route
          path={ROUTES.ADMIN_RESERVATIONS}
          element={<AdminProtectedRoute isAuthenticated={isAdminAuthenticated}><AdminReservations /></AdminProtectedRoute>}
        />
        <Route
          path={ROUTES.ADMIN_OWNERS}
          element={<AdminProtectedRoute isAuthenticated={isAdminAuthenticated}><AdminOwners /></AdminProtectedRoute>}
        />
        <Route
          path={ROUTES.ADMIN_QUARTIERS}
          element={<AdminProtectedRoute isAuthenticated={isAdminAuthenticated}><AdminQuartiers /></AdminProtectedRoute>}
        />
        <Route
          path={ROUTES.ADMIN_TYPES}
          element={<AdminProtectedRoute isAuthenticated={isAdminAuthenticated}><AdminTypes /></AdminProtectedRoute>}
        />
        <Route
          path={ROUTES.ADMIN_USERS}
          element={<AdminProtectedRoute isAuthenticated={isAdminAuthenticated}><AdminUsers /></AdminProtectedRoute>}
        />
        <Route
          path={ROUTES.ADMIN_ADMINS}
          element={<AdminProtectedRoute isAuthenticated={isAdminAuthenticated}><AdminAdmins /></AdminProtectedRoute>}
        />
        <Route
          path={ROUTES.ADMIN_STATS}
          element={<AdminProtectedRoute isAuthenticated={isAdminAuthenticated}><AdminStats /></AdminProtectedRoute>}
        />
        <Route
          path={ROUTES.ADMIN_AUDIT_LOGS}
          element={<AdminProtectedRoute isAuthenticated={isAdminAuthenticated}><AdminAuditLogs /></AdminProtectedRoute>}
        />

        <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;